import {
  type ClassNameValue,
  extendTailwindMerge,
  twJoin,
} from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-1", "text-2", "text-3",
        "text-4", "text-5", "text-6",
        "text-7", "text-8", "text-9",
      ],
    },
  },
});

const cn = (...inputs: ClassNameValue[]): string => {
  return twMerge(twJoin(inputs));
};

export { cn };
